import React, { useState, useContext, useEffect, useRef } from 'react';

import quizInstanceAdminStatusContext from '../context/quizInstanceAdminStatusContext';

export default function QuizAdminAnswerTextList(props) {

  const {

    question,
    answerList,
    shouldFadeAnswers = true

  } = props;

  const ctx = useContext(quizInstanceAdminStatusContext);
  const [rerender, setRerender] = useState(false);
  const [idxHidden, setIdxHidden] = useState({});
  const renderCountRef = useRef(0);
  const bottomElRef = useRef(null);

  // ================================================================
  // This effect updates the render count and triggers a re-render.
  // This will cause the answer text boxes to begin to fade out.
  // ================================================================
  useEffect(() => {

    renderCountRef.current = answerList.length;
    console.log(renderCountRef);
    setTimeout(() => setRerender(true), 50);

  }, [answerList]);

  // ================================================================
  // If we have re-rendered (triggered above), scroll to the bottom.
  // ================================================================
  useEffect(() => {
    if (rerender) {
      setRerender(false);
      bottomElRef?.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [rerender, bottomElRef]);

  const color = ctx.quizStyle.colorList[(question.order - 1) % ctx.quizStyle.colorList.length];

  return (
    <>
      <div className="text-center quizQuestionHeader" style={{backgroundColor: color.primaryCss, color: "#fff", borderRadius: "0px 0px 13px 0px" }}>
        <h4 className="quizQuestionHeaderText" style={{padding: "10px 16px"}}>FRÅGA {question.order}</h4>
      </div>

      <div className="quizAdminAnswerTextListQuestion text-dark mt-2" style={{borderColor: color.primaryCss}}>
        <h3 className="quizQuestionText">{question.markdown}</h3>
      </div>


      <div className="quizAdminAnswerTextList px-2">
        {answerList.map((answer, idx) => 
          {
            const showAnswer = !shouldFadeAnswers || !idxHidden[idx];
            const startFadeout = shouldFadeAnswers && idx + 1 <= renderCountRef.current;

            return showAnswer && <div
              className={`quizQuestion quizAnswerTextBar mt-2 mb-2 ${startFadeout ? "delayed-fadeout" : ""}`}
              onTransitionEnd={() => setIdxHidden({...idxHidden, [idx]: 1})}
              style={{ backgroundColor: color.primaryCss }}>

              <div className="weight-bold quizAnswerTextContent">
                {answer.answerText}
              </div>

              <div className="quizAnswerMetadataWrapper">
                <div className="d-inline-block font-italic ml-2">
                  {new Date(answer.createdAt).toLocaleString("sv-SE", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}
                </div>

                <div className="d-inline-block ml-2 font-italic">
                  {answer.participantAlias}
                </div>
              </div>

            </div>
          }
        )}
        <div ref={bottomElRef}></div>
      </div>
    </>
  );
}